import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import UserTypesEnum from "../../../../models/UserTypesEnum";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import styled from "styled-components";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import TitleTagEnum from "../../../../models/TitleTagEnum";
import SupplierContext from "../../../../contexts/SupplierContext";
import * as _ from "lodash-es";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwButton from "../../../shared/OwButton/OwButton";
import { Socket } from "socket.io-client";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IUpdateSupplierSettingsDTO from "../../../../models/DTO/IUpdateSupplierSettingsDTO";
import UserContext from "../../../../contexts/UserContext";
import IOnUpdateSupplierSettingsDTO from "../../../../models/DTO/IOnUpdateSupplierSettingsDTO";
import INotification from "../../../../models/INotification";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";

type Props = {
    closeFn: () => void;
    socket: Socket;
    notifyFn: (data: any, notification: INotification) => void;
};

export const EditScreenOptions = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    let existingScreenOptions: any = {};

    if (_.isString(supplierModel.settings)) {
        const parsedSetings = JSON.parse(supplierModel.settings);

        existingScreenOptions = parsedSetings?.screen_options || {};
    } else {
        existingScreenOptions = supplierModel.settings?.screen_options || {};
    }

    const [screenOptions, setScreenOptions] = useState(existingScreenOptions);
    const [saveActive, setSaveActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierSettings, onUpdateSupplierSettings);

        return () => {
            props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierSettings, onUpdateSupplierSettings);
        };
    }, []);

    const updateSupplierSettings = () => {
        const data: IUpdateSupplierSettingsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            settings: {
                screen_options: screenOptions,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, data);

        setSaveActive(true);
    };

    const onUpdateSupplierSettings = (data: IOnUpdateSupplierSettingsDTO) => {
        setSaveActive(false);

        const notification: INotification = {
            title: "successfully_updated_settings",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        props.notifyFn(null, notification);

        props.closeFn();
    };

    const screens = [
        // 'orders',
        "catalogs",
        // 'inventory',
        // 'quotes',
        // 'shipping',
        // 'pick_lists',
        // 'packing_lists',
        // 'warehouses',
        // 'accounts',
        // 'account_users',
        // 'users',
    ];

    const userTypes = [
        { value: UserTypesEnum.ADMIN, title: "admin" },
        { value: UserTypesEnum.SALES, title: "sales" },
        { value: UserTypesEnum.ORDER_MGMT, title: "order_mgmt" },
        { value: UserTypesEnum.SHIP_MGMT, title: "ship_mgmt" },
        { value: UserTypesEnum.INVENTORY_MGMT, title: "inventory_mgmt" },
        // {value: UserTypesEnum.SUPPORT, title: "support"},
        // {value: UserTypesEnum.MANAGEMENT, title: "management"},
    ];

    const updateScreenOption = (screen: string, userType: UserTypesEnum, type: "READ" | "EDIT", e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;

        const updatedScreenOptions: any = { ...screenOptions };

        if (!updatedScreenOptions[screen]) {
            updatedScreenOptions[screen] = {
                [UserTypesEnum.ADMIN]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.SALES]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.ORDER_MGMT]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.SHIP_MGMT]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.INVENTORY_MGMT]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.SUPPORT]: {
                    READ: false,
                    EDIT: false,
                },
                [UserTypesEnum.MANAGEMENT]: {
                    READ: false,
                    EDIT: false,
                },
            };
        }

        updatedScreenOptions[screen][userType][type] = value;

        setScreenOptions(updatedScreenOptions);
    };

    const saveOptions = () => {
        updateSupplierSettings();
    };

    return (
        <div className={"EditScreenOptions"}>
            <div className={"EditScreenOptions__title"}>
                <OwTitle title={"edit_screen_options"} />
                <OwButton title={"save"} fn={saveOptions} disableOnActive={true} active={saveActive} />
            </div>

            <ScreenContainerDiv className={"EditScreenOptions__options"}>
                {screens.map((screen, index) => {
                    return (
                        <div key={index} className={"EditScreenOptions__option"}>
                            <div className={"EditScreenOptions__option__title"}>
                                <OwTitle tag={TitleTagEnum.H4} title={screen} />
                            </div>
                            <div>
                                {userTypes.map((userType, indexTwo) => {
                                    return (
                                        <div key={"_" + indexTwo} className={"mb-3"}>
                                            <div>
                                                <OwLabel title={userType.title} />
                                            </div>
                                            <div>
                                                <OwCheckbox
                                                    label={"read"}
                                                    name={screen + "_read"}
                                                    fn={(e) => updateScreenOption(screen, userType.value, "READ", e)}
                                                    truthyVal={true}
                                                    falsyVal={false}
                                                    checked={
                                                        screenOptions[screen] &&
                                                        screenOptions[screen][userType.value] &&
                                                        screenOptions[screen][userType.value].READ
                                                    }
                                                />
                                            </div>
                                            <div>
                                                <OwCheckbox
                                                    label={"edit"}
                                                    name={screen + "_edit"}
                                                    fn={(e) => updateScreenOption(screen, userType.value, "EDIT", e)}
                                                    truthyVal={true}
                                                    falsyVal={false}
                                                    checked={
                                                        screenOptions[screen] &&
                                                        screenOptions[screen][userType.value] &&
                                                        screenOptions[screen][userType.value].EDIT
                                                    }
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </ScreenContainerDiv>
        </div>
    );
};

const ScreenContainerDiv = styled.div`
    display: grid;
    grid-auto-columns: auto;
    grid-auto-flow: column;
`;
